import { AppointmentsDto } from './appointments.dto';
import { AppointmentToUserTypeEnum, AppointmentUsersInterface } from '../../..';
import { UserDto } from './user.dto';

export class AppointmentUsersDto implements AppointmentUsersInterface{
  appointmentToUserType: AppointmentToUserTypeEnum;
  appointment: AppointmentsDto;
  user: UserDto;
}
